function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUhyperbox(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#526075",
    fillRule: "evenodd",
    d: "M12.557 2.612l7.725 4.22c.24.16.478.558.478.877v8.6c0 .32-.239.717-.478.877l-7.725 4.22a.957.957 0 01-1.114 0l-7.725-4.22c-.24-.16-.478-.558-.478-.876V7.709c0-.319.239-.717.478-.876l7.725-4.221a.957.957 0 011.114 0zM5.455 14.477a.578.578 0 00-.071.278v.384a1 1 0 00.52.877l4.33 2.374a.578.578 0 00.856-.508v-.384a1 1 0 00-.519-.877L6.24 14.248a.578.578 0 00-.785.23zM12 4.523L6.187 7.71 12 10.894l5.813-3.185L12 4.523z"
  }));
}

SvgUhyperbox.clsName = 'icon-www__uhyperbox';
SvgUhyperbox.remarkName = 'unknown';
export default SvgUhyperbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Uhyperbox.js
// module id = 2487
// module chunks = 17 18